import * as React from "react";
import {
    LanguageDto,
    OptionBasicDto,
    OptionBasicReferenceDto,
    OptionTextDto
} from "../../../../services/Client";
import {IDataTwoLanguageInput, IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import {Flag, Icon, Label, Modal, Table} from "semantic-ui-react";
import {compose, Dispatch} from "redux";
import {connect} from "react-redux";
import BaseOptionViewActions from "../../../../redux/actions/BaseOptionViewActions";
import {RouteComponentProps, withRouter} from "react-router";
import {IReduxState} from "../../../../redux/IReduxState";
import {selectLanguageList} from "../../../../redux/selectors";
import {IMultiLineValue, lang2flag} from "../../../MultiLineColumn";
import * as _ from "lodash";
import {translate} from "react-i18next";
import Button from "../../../Button";
import {createMultiLineValues} from "../../../../views/BaseOptionsView/BaseOptionsTextUtils";
import {getUniqueGenerations} from "./optionIndicator/OptionIndicatorViewUtils";
import ColumnFactory from "../../../../services/ColumnFactory";
import PromtFormatter from "../reactQuill/PromtFormatter";

interface IMapDispatchToProps {
    getReferences: (
        dto: OptionBasicDto,
        setMessage: (message: string) => void,
        setResult: (references: OptionBasicReferenceDto[]) => void
    ) => void;
}

interface IMapStateToProps {
    languageList?: LanguageDto[];
}

interface IOwnProps extends IVirtualizedTableCellComponentProps { }

interface IReferenceCellProps extends IMapStateToProps, IOwnProps, IMapDispatchToProps, RouteComponentProps<any> { }

interface IReferenceCellState {
    optionBasicReferences: OptionBasicReferenceDto[];
    message: string;
    isOpen: boolean;
}

class ReferenceCell extends React.Component<IReferenceCellProps, IReferenceCellState> {
    constructor(props: IReferenceCellProps) {
        super(props);
        this.state = {
            optionBasicReferences: [],
            message: "",
            isOpen: false,
        };
    }

    setMessage = (message: string) => {
        this.setState({message});
    }

    setResult = (result: OptionBasicReferenceDto[]) => {
        this.setState({optionBasicReferences: result});
    }

    redirectToPsl = (typefamilyId: number) => {
        const currentPath = window.location.origin;
        window.open(`${currentPath}/options/${this.props.match.params.modelyear}/${typefamilyId}/148?isNewTable=true`);
    }

    clearState() {
        this.setState({
            optionBasicReferences: [],
            message: "",
            isOpen: false,
        });
    }

    openModal() {
        this.setState({
            isOpen: true,
        });
    }

    createMultiLineValues = (texts: OptionTextDto[], propName: string, langList: LanguageDto[]): IMultiLineValue[] => {
        const values: IMultiLineValue[] = [];

        // add multi line values in the order of the sytem languages
        langList.forEach((language: LanguageDto) => {
            // try to find a text in the given language
            const text = _.find(texts, (dto: OptionTextDto) => (
                dto.language !== undefined && dto.language.objectId === language.objectId
            ));
            if (text && text[propName] !== undefined) {
                values.push({
                    caption: language.nameDe,
                    text: text[propName],
                    flag: lang2flag(language.vmce),
                });
            }
        });
        return values;
    }

    render() {
        const {languageList, t} = this.props;
        const languages = languageList ? languageList : [];

        const obShortText: IMultiLineValue[] = createMultiLineValues(this.props.value.dto.texts, "shorttext", languages);
        const obLongText: IMultiLineValue[] =  createMultiLineValues(this.props.value.dto.texts, "longtext", languages);

        const obShortTextObj: IDataTwoLanguageInput = obShortText
            .reduce(
                (result, value) => ({...result,
                    [value.flag as string]: { flag: value.flag, value: value.text}}),
                {});
        const obLongtextObj: IDataTwoLanguageInput = obLongText
            .reduce(
                (result, value) => ({...result,
                    [value.flag as string]: { flag: value.flag, value: value.text}}),
                {});

        return this.props.value.optionCount === undefined || this.props.value.optionCount === 0
            ?
            (
                <div className='reference-cell-total-count'>
                    <span>{0}</span>
                    <Icon name='sitemap' />
                </div>
            )
            :
            (
                <Modal
                    className="references-dialog-container"
                    open={this.state.isOpen}
                    size={"large"}
                    trigger={
                        <div className='reference-cell-total-count' style={{cursor: "pointer"}} onClick={() => this.openModal()}>
                            <span>{this.props.value.optionCount}</span>
                            <Icon name='sitemap' />
                        </div>}
                    onOpen={() => this.props.getReferences(this.props.value.dto, this.setMessage, this.setResult)}
                    onClose={() => this.clearState()}
                >
                    <React.Fragment>
                        <div className="option-basic-reference">
                            <p
                                style={{
                                    fontSize: 16,
                                    fontWeight: "bold",
                                }}
                            >
                                {t("GLOBAL:OPTION_BASIC")}
                            </p>
                            <div className="references-dialog-table-container">
                                <Table
                                    id="optionBasicReferenceTable"
                                    textAlign='left'
                                    verticalAlign='middle'
                                    className="ui striped table"
                                    celled={true}
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>
                                                {`${t("GLOBAL:MODELYEAR")} ${ColumnFactory.mj2str(this.props.value.dto.modelyear)}`}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:SHORTTEXT")}
                                                    icon={<Flag name={'de'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:SHORTTEXT")}
                                                    icon={<Flag name={'gb'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={4}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:LONGTEXT")}
                                                    icon={<Flag name={'de'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={4}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:LONGTEXT")}
                                                    icon={<Flag name={'gb'} />}
                                                />
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        <Table.Row key={this.props.value.dto.objectId}>
                                            <Table.Cell>
                                                {`${this.props.value.dto.categoryText.text}, ${this.props.value.dto.optionCode}`}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {obShortTextObj.de !== undefined ? obShortTextObj.de.value : ''}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {obShortTextObj.gb !== undefined ? obShortTextObj.gb.value : ''}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {obLongtextObj.de !== undefined ? <PromtFormatter value={obLongtextObj.de.value || ""} /> : ''}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {obLongtextObj.gb !== undefined ? <PromtFormatter value={obLongtextObj.gb.value || ""} /> : ''}
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>

                        <div className="option-basic-option-reference">
                            <p
                                style={{
                                    fontSize: 16,
                                    fontWeight: "bold",
                                }}
                            >
                                {t("OB_REFERENCE:REFERENCED_PSLS")}
                            </p>
                            <div className="references-option-dialog-table-container">
                                <Table
                                    id="optionBasicOptionReferenceTable"
                                    textAlign='left'
                                    verticalAlign='middle'
                                    className="ui striped table"
                                    celled={true}
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>{t("GLOBAL:TYPEFAMILY")}</Table.HeaderCell>
                                            <Table.HeaderCell>{t("COLUMN_FACTORY:GENERATION")}</Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:SHORTTEXT")}
                                                    icon={<Flag name={'de'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:SHORTTEXT")}
                                                    icon={<Flag name={'gb'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={4}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:LONGTEXT")}
                                                    icon={<Flag name={'de'} />}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={4}>
                                                <Label
                                                    basic={true}
                                                    className="textCompareBlockLabel"
                                                    content={t("COLUMN_FACTORY:LONGTEXT")}
                                                    icon={<Flag name={'gb'} />}
                                                />
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {this.state.optionBasicReferences
                                            .map((dto: OptionBasicReferenceDto, index: number) => {
                                                const shortText: IMultiLineValue[] = dto.optionTexts
                                                    ? this.createMultiLineValues(dto.optionTexts, "shorttext", languages)
                                                    : [];
                                                const longtext: IMultiLineValue[] = dto.optionTexts
                                                    ? this.createMultiLineValues(dto.optionTexts, "longtext", languages)
                                                    : [];

                                                const shortTextObj: IDataTwoLanguageInput = shortText
                                                    .reduce(
                                                        (result, value) => ({
                                                            ...result,
                                                            [value.flag as string]: {flag: value.flag, value: value.text}
                                                        }),
                                                        {});
                                                const longtextObj: IDataTwoLanguageInput = longtext
                                                    .reduce(
                                                        (result, value) => ({
                                                            ...result,
                                                            [value.flag as string]: {flag: value.flag, value: value.text}
                                                        }),
                                                        {});

                                                return (<Table.Row key={index}>
                                                    <Table.Cell
                                                        onClick={() => this.redirectToPsl(dto.typefamilyId)}
                                                        className='reference-cell-link-pair'
                                                    >
                                                        {dto.typefamilyName}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {getUniqueGenerations(dto.generation)}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {shortTextObj.de !== undefined ? shortTextObj.de.value : ''}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {shortTextObj.gb !== undefined ? shortTextObj.gb.value : ''}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {longtextObj.de !== undefined ? <PromtFormatter value={longtextObj.de.value || ""} /> : ''}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {longtextObj.gb !== undefined ? <PromtFormatter value={longtextObj.gb.value || ""} /> : ''}
                                                    </Table.Cell>
                                                </Table.Row>
                                                );
                                            })
                                        }
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>
                    </React.Fragment>
                    <Modal.Actions>
                        {
                            [
                                <Button
                                    key={"cancelButton"}
                                    icon={"ban"}
                                    onClick={() => this.clearState()}
                                />
                            ]
                        }
                    </Modal.Actions>
                </Modal>
            );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => {
    return {
        getReferences: (dto, setMessage, setResult) =>
            dispatch(BaseOptionViewActions.GetOptionBasicReferences(dto, setMessage, setResult)),
    };
};

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    languageList: selectLanguageList(state),
});

export default compose<React.ComponentType<IOwnProps>>(
    withRouter,
    translate(["OB_REFERENCE", "GLOBAL", "COLUMN_FACTORY"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ReferenceCell);



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/ReferenceCell.tsx